import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sobre from "../pages/sobre/page";
import Especialidades from "../pages/especialidades/page";
import Estrutura from "../pages/estrutura/page";
import Blog from "../pages/blog/page";
import Contato from "../pages/contato/page";
import DraNathalia from "../pages/dra-nathalia/page";
import DraMaynaMoura from "../pages/dra-mayna-moura/page";
import PoliticaPrivacidade from "../pages/politica-privacidade/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dra-nathalia",
    element: <DraNathalia />,
  },
  {
    path: "/dra-mayna-moura",
    element: <DraMaynaMoura />,
  },
  {
    path: "/especialidades",
    element: <Especialidades />,
  },
  {
    path: "/sobre",
    element: <Sobre />,
  },
  {
    path: "/estrutura",
    element: <Estrutura />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/politica-privacidade",
    element: <PoliticaPrivacidade />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;